import React from 'react';

const ArrowDownIcon = (props) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      viewBox='0 0 490.656 490.656'
      shapeRendering='geometricPrecision'
      textRendering='geometricPrecision'
      width='1em'
      height='1em'
      {...props}
    >
      <g id='prefix__eG2cjAJCVKE2'>
        <g id='prefix__eG2cjAJCVKE3'>
          <g transform='rotate(-90 244.328 1)'>
            <path
              id='prefix__eG2cjAJCVKE4'
              d='M487.536 120.445c-4.16-4.16-10.923-4.16-15.083 0L245.339 347.581 18.203 120.467c-4.16-4.16-10.923-4.16-15.083 0s-4.16 10.923 0 15.083l234.667 234.667a10.716 10.716 0 007.552 3.115c2.731 0 5.461-1.045 7.531-3.136l234.667-234.667c4.159-4.161 4.159-10.924-.001-15.084z'
              transform='translate(-245.328 -245.328)'
              fill='#000'
              stroke='none'
              strokeWidth={1}
            />
          </g>
        </g>
      </g>
    </svg>
  );
};

export default ArrowDownIcon;
